import Vue from 'vue'
import vuetify from './plugins/vuetify'
import store from './store'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import { applyVuetifyTheme, applyBrandingSideEffects } from '@/utils/tenantBranding'
import i18n from './i18n'
import './plugins/dayjs'
import '@fontsource/ibm-plex-sans-thai/100.css';
import '@fontsource/ibm-plex-sans-thai/200.css';
import '@fontsource/ibm-plex-sans-thai/300.css';
import '@fontsource/ibm-plex-sans-thai/400.css';
import '@fontsource/ibm-plex-sans-thai/500.css';
import '@fontsource/ibm-plex-sans-thai/600.css';
import '@fontsource/ibm-plex-sans-thai/700.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';

import { msalInstance } from './authConfig'
import { msalPlugin } from './plugins/msalPlugin'
import { EventType } from '@azure/msal-browser'
import VCalendar from 'v-calendar';
import './registerServiceWorker'


Vue.config.productionTip = false

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
}

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account
    msalInstance.setActiveAccount(account)
  }
})

Vue.use(msalPlugin, msalInstance)
Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});

const persistedBranding = store.state.User?.tenantBranding
if (persistedBranding?.primaryColor || persistedBranding?.appBarColor || persistedBranding?.logo) {
  applyVuetifyTheme(vuetify, persistedBranding)
  applyBrandingSideEffects(persistedBranding)
} else {
  applyBrandingSideEffects(null)
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
